<template>
    <div class="bracket-graph-frame bracket-graph-loading" :class="{ 'is-embedded': embedded }">
        <LoadingSpinner2 />
    </div>
</template>

<script setup lang="ts">
    import { inject } from "vue";
    import LoadingSpinner2 from "../../Common/LoadingSpinner2.vue";

    // Placeholder shown while the graph bracket's async chunk (@vue-flow/core) loads.
    // It reserves exactly the same space as the mounted viewport via the shared
    // .bracket-graph-frame class, so the surrounding page does not shift when the
    // real canvas swaps in. defineAsyncComponent renders loading components without
    // props, so the embedded flag comes from a provide() in PublicBracketApp.vue.
    const embedded = inject<boolean>("bracketEmbedded", false);
</script>
